/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { IconDown } from '@americanexpress/dls-react';
import PropTypes from 'prop-types';
import { saveSearchListStyle, searchSelectStyle } from '../../../styles/AdvancedFormSearch/AdvStyleList';
import { callApi } from '../../../utils';

export const DropdownIndicator = () => (
  <div>
    <IconDown
      size="sm"
      theme={{
        color: '#53565A !important',
        fill: '#53565A !important',
      }}
    />
  </div>
);

const AdvFormSearchSelectItem = React.memo(({
  formField, pageData, setPageData, acsMgmt, loginData,
}) => {
  const {
    id,
    value,
    apiResultFiledNm,
    apiPath,
    apiFullPath,
    dataFields = { value: 'value', label: 'label' },
    name,
    suggestionList: providedSuggestionList = [],
  } = formField;
  const [suggestionList, setSuggestionList] = useState(providedSuggestionList);
  const [selectedValue, setSelectedValue] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('Result set not found');

  const handleOnChange = (e, currId) => {
    const updatedPageData = { ...pageData };
    updatedPageData.formFields[currId].value = e ? e.value : '';
    setSelectedValue(e);
    setPageData(updatedPageData);
  };

  const handleFormFieldData = async () => {
    setSuggestionList([]);
    setIsLoading(true);
    if (apiFullPath || apiPath) {
      const apiEndPoint = apiFullPath || (acsMgmt + apiPath);
      const { data, isError } = await callApi(apiEndPoint, 'GET', null, loginData);
      if (!isError) {
        if (typeof data !== 'undefined' && data !== null) {
          let respData = [];
          const parsedRespData = [];
          if (apiResultFiledNm) {
            respData = data[apiResultFiledNm];
          } else {
            respData = data;
          }
          respData.forEach((resp) => {
            parsedRespData.push({ value: resp[dataFields.value], label: resp[dataFields.label] });
          });
          setSuggestionList(parsedRespData);
        } else {
          setErrorMsg('Result set not found');
        }
      } else {
        setErrorMsg('Error occurred');
      }
    }
    setIsLoading(false);
  };
  useEffect(() => {
    // api call to get the list
    (async () => {
      await handleFormFieldData();
    })();
    const defaultSelectedValue = suggestionList.filter((item) => item.value === value);
    if (defaultSelectedValue.length > 0) {
      setSelectedValue(defaultSelectedValue[0]);
    }
  }, []);

  useEffect(() => {
    const defaultSelectedValue = suggestionList.filter((item) => item.value === value);
    if (defaultSelectedValue.length > 0) {
      setSelectedValue(defaultSelectedValue[0]);
    } else {
      setSelectedValue(null);
    }
  }, [value, suggestionList]);

  // When provided suggestionList change
  useEffect(() => {
    setSuggestionList(providedSuggestionList);
  }, [providedSuggestionList]);

  const selectStyles = {
    control: (provided) => searchSelectStyle(provided),
    menu: () => saveSearchListStyle['.menu'],
  };
  const style = css`
  & > div > div {
    margin-left: 0px;
  }
`;

  return (
    <div css={style}>
      <Select
        isLoading={isLoading}
        components={{ DropdownIndicator, IndicatorSeparator: null }}
        hideSelectedOptions={false}
        isClearable={true}
        onChange={(e) => {
          handleOnChange(e, id);
        }}
        options={suggestionList}
        placeholder="Select.."
        styles={selectStyles}
        tabSelectsValue={true}
        defaultValue={selectedValue}
        noOptionsMessage={() => errorMsg}
        id={`${name}-searchSelect-dropdown`}
        instanceId={name}
        value={selectedValue}
      />
    </div>
  );
});

AdvFormSearchSelectItem.propTypes = {
  formFields: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }),
  pageData: PropTypes.shape({
    formHeader: PropTypes.string,
    formFields: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
      })
    ),
  }),
  setPageData: PropTypes.func.isRequired,
  acsMgmt: PropTypes.node.isRequired,
  loginData: PropTypes.shape({}),
};

export default AdvFormSearchSelectItem;
